<div class="pos-panel">
    <div class="pos-no-entities-wrapper h-100">
        <div class="pos-no-entities-indicator">
            <span class="material-icons-round pos-no-entities-icon">home</span>
            <span class="soc-h2 text-center">{{'VENUE.NO_VENUES' | translate}}</span>
            <span class="soc-p text-center">{{(isUserGMN() ? 'VENUE.CREATE_VENUES_GMN' : 'VENUE.CREATE_VENUES_MN') | translate}}</span>
            <button *ngIf="isUserGMN()" class="soc-basic-cyan-btn" (click)="redirectToSocialliteManager()">{{'VENUE.GO_TO_MANAGER' | translate}}</button>
        </div>
    </div>
  </div>
  